import { inputResult } from "../Submit/SaveAnswer";


export function transformIfToSelf(input:JQuery, results:inputResult, points:number, possible:number){
    
    input.prop('readonly', true);
    input.val(results.answer);

}